var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiRsUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-rs-user"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01 align center"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.6666 18.8893H15.1851V15.1538C15.1845 14.573 14.9536 14.0163 14.5429 13.6056C14.1323 13.195 13.5755 12.964 12.9947 12.9634H7.0051C6.42436 12.964 5.86757 13.195 5.45693 13.6056C5.04628 14.0163 4.81532 14.573 4.81473 15.1538V18.8893H3.33325V15.1538C3.33443 14.1803 3.72166 13.247 4.41001 12.5587C5.09836 11.8703 6.03163 11.4831 7.0051 11.4819H12.9947C13.9682 11.4831 14.9015 11.8703 15.5898 12.5587C16.2782 13.247 16.6654 14.1803 16.6666 15.1538V18.8893Z",
    fill: "#57689F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.99987 9.99997C9.12084 9.99997 8.26155 9.73931 7.53067 9.25095C6.79978 8.76259 6.23012 8.06846 5.89374 7.25635C5.55735 6.44423 5.46933 5.5506 5.64082 4.68846C5.81231 3.82632 6.2356 3.0344 6.85717 2.41283C7.47874 1.79127 8.27066 1.36797 9.1328 1.19648C9.99494 1.02499 10.8886 1.11301 11.7007 1.4494C12.5128 1.78579 13.2069 2.35544 13.6953 3.08633C14.1836 3.81721 14.4443 4.6765 14.4443 5.55553C14.4431 6.73391 13.9745 7.86369 13.1413 8.69693C12.308 9.53017 11.1782 9.9988 9.99987 9.99997V9.99997ZM9.99987 2.59257C9.41385 2.59257 8.84099 2.76634 8.35373 3.09192C7.86648 3.41749 7.48671 3.88024 7.26245 4.42165C7.03819 4.96306 6.97951 5.55882 7.09384 6.13358C7.20816 6.70833 7.49036 7.23628 7.90474 7.65066C8.31911 8.06504 8.84706 8.34723 9.42182 8.46156C9.99658 8.57589 10.5923 8.51721 11.1337 8.29295C11.6752 8.06869 12.1379 7.68892 12.4635 7.20166C12.7891 6.71441 12.9628 6.14155 12.9628 5.55553C12.9628 4.7697 12.6507 4.01606 12.095 3.4604C11.5393 2.90474 10.7857 2.59257 9.99987 2.59257Z",
    fill: "#57689F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRsUser);
export default __webpack_public_path__ + "static/media/fi-rs-user.6973dda1ba2e9dd151c89f0a86a8c434.svg";
export { ForwardRef as ReactComponent };